import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { effect, inject, Injectable, signal } from '@angular/core';
import { AppConfigService } from '@sphere/platform';
import { environment } from '@env/environment';
import { explicitEffect } from 'ngxtension/explicit-effect';
import { Observable } from 'rxjs';

export const xAppInterceptor: HttpInterceptorFn = (req, next) => {
    const config = inject(AppConfigService);

    const xAppHeaderVersion = `sphere-web:${environment.build?.version}`;
    let includedUrls: string[] = [];

    if (config.ready()) {
        includedUrls = ['/api', config.apiGatewayUrl + 'api', config.apiGatewayUrl + '/api'];
    }

    let nextReq: HttpRequest<any> = req;
    if (xAppHeaderVersion && includeUrl(includedUrls, req.url)) {
        nextReq = req.clone({
            setHeaders: {
                'X-App': xAppHeaderVersion
            }
        });
    }

    return next(nextReq);
};

function includeUrl(includedUrls: string[], url: string): boolean {
    return includedUrls.some(includedUrl => url.startsWith(includedUrl));
}
